import { AudioWaveform, Brain, ScanLine, ShieldX } from "lucide-react";

// Generate AI report button

export const AI_REPORT_ENABLED_USERS = [
  "688755f5c92b6b6e21ad036e",
  "688755f5c92b6b6e21ad0364",
  "688755f5c92b6b6e21ad036a",
  "69254bd1d13ac7b9f601131a",
  "688755f5c92b6b6e21ad0368",
  "688755f5c92b6b6e21ad0363",
  "688755f5c92b6b6e21ad0362",
  "69254e4ed13ac7b9f6011405",
  "692eb90c2e96c503505d34a4",
  "694cf6a1b9b10e951e222af2",
];

export const modalitiesDatas = [
  {
    id: "mri",
    name: "MRI",
    icon: Brain,
    color: "text-blue-400",
  },
  {
    id: "ct",
    name: "CT",
    icon: ScanLine,
    color: "text-blue-400",
  },
  {
    id: "x-ray",
    name: "X-Ray",
    icon: ShieldX,
    color: "text-green-400",
  },
  {
    id: "ultrasound",
    name: "Ultrasound",
    icon: AudioWaveform,
    color: "text-green-400",
  },
]